/**
 * Sorts an array of customers alphabetically by their first name or company name.
 *
 * @param {Array} customers - The array of customer objects to sort.
 * @returns {Array} - The sorted array of customers.
 */
export function alphabeticallySort(customers = []) {
    return customers.sort(function (a, b) {
        if (a.type === "customer" && b.type === "customer") {
            return a.first_name.localeCompare(b.first_name);
        } else {
            return a.company_name.localeCompare(b.company_name);
        }
    });
}